// @vendor
const PropTypes = require('prop-types');
const React = require('react');

// @components
const EcommerceKeyShowOrHideNonExpired = require('./myProfileEcommerceKeyShowOrHideNonExpired');
const EcommerceKeyShowOrHideExpired = require('./myProfileEcommerceKeyShowOrHideExpired');

// @ constants
const {EXPIRATION_CODE_TIME_CHALLENGE} = require('constants/index');
const { CHALLENGE_PAGE, SUCCESSFUL_OPERATION } = require("constants/biocatch");

// @ utilities
const { changeBiocatchContext } = require("utilities/biocatch");

class EcommerceKeyShowOrHide extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { ecommerceKey, setExpired } = this.props;
        changeBiocatchContext(SUCCESSFUL_OPERATION);
        if (ecommerceKey) {
            this.expirationTimeout = setTimeout(setExpired, EXPIRATION_CODE_TIME_CHALLENGE);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.expirationTimeout);
    }

    render() {
        const { 
            ecommerceKey,
            messageExpired,
            messageShortNonExpired,
            newRequestText,
            reset,
            textBack,
            textNewRequest,
            title
        } = this.props;

        let bodyContent;
        const linkToBack = '/myprofile/keys/ecommerce'

        if (!!ecommerceKey) {
            bodyContent = (
                <EcommerceKeyShowOrHideNonExpired
                    ecommerceKey={ecommerceKey}
                    linkToBack={linkToBack}
                    messageShortNonExpired={messageShortNonExpired}
                    textBack={textBack}
                    title={title}
                />
            );
        } else {
            bodyContent = (
                <EcommerceKeyShowOrHideExpired
                    linkToBack={linkToBack}
                    messageExpired={messageExpired}
                    messageShortNonExpired={messageShortNonExpired}
                    newRequestText={newRequestText}
                    textBack={textBack}
                    textNewRequest={textNewRequest}
                    title={title}
                    triggerNewRequest={() => {
                        changeBiocatchContext(CHALLENGE_PAGE);
                        reset();
                    }}
                />
            )
        }
        return (
            <section className="code-confirmation-success">
                {bodyContent}
            </section>
        );
    }
}

EcommerceKeyShowOrHide.propTypes = {
    ecommerceKey: PropTypes.string,
    messageExpired: PropTypes.string.isRequired,
    messageShortNonExpired: PropTypes.string.isRequired,
    newRequestText: PropTypes.string,
    reset: PropTypes.func.isRequired,
    setExpired: PropTypes.func.isRequired,
    textBack: PropTypes.string,
    textNewRequest: PropTypes.string,
    title: PropTypes.string
};

module.exports = EcommerceKeyShowOrHide;